<button
  pButton
  [pTooltip]="gridStore.readonly() ? 'Ansicht editieren' : 'Vorschau'"
  tooltipPosition="top"
  [rounded]="true"
  [icon]="gridStore.readonly() ? 'fas fa-pen' : 'fas fa-eye'"
  (click)="editAtlasToggle()"></button>
